import React from 'react';
import { Link } from 'react-router-dom';
import { PlayCircle, Headphones, FileText, Download } from 'lucide-react';
import { getDownloadUrl } from '../../utils/mediaUtils';
import { lessonFileName } from './genzContent';

const secondaryCls =
  'flex items-center justify-center gap-2 w-full px-4 py-2.5 border border-slate-300 text-slate-700 bg-white font-body font-medium text-sm rounded hover:border-brand-accent hover:text-brand-accent transition-colors duration-300';

// Order is fixed: Watch Video (primary) -> Audio -> PDF -> Video download
export const LessonMediaButtons = ({ lesson, onWatch }) => {
  const id = lesson.order;
  return (
    <div className="flex flex-col gap-2.5">
      {lesson.video_url && (
        onWatch ? (
          <button
            onClick={onWatch}
            className="flex items-center justify-center gap-2 w-full px-5 py-3.5 bg-brand-accent text-white font-body font-semibold text-base rounded shadow-md hover:bg-brand-accent-hover hover:shadow-lg transition-colors duration-300"
            data-testid={`lesson-watch-video-${id}`}
          >
            <PlayCircle className="h-5 w-5" /> Watch Video
          </button>
        ) : (
          <Link
            to={`/gen-z/${lesson.slug}#watch`}
            className="flex items-center justify-center gap-2 w-full px-5 py-3.5 bg-brand-accent text-white font-body font-semibold text-base rounded shadow-md hover:bg-brand-accent-hover hover:shadow-lg transition-colors duration-300"
            data-testid={`lesson-watch-video-${id}`}
          >
            <PlayCircle className="h-5 w-5" /> Watch Video
          </Link>
        )
      )}
      {lesson.audio_url && (
        <a href={getDownloadUrl(lesson.audio_url, lessonFileName(lesson, 'mp3'))} className={secondaryCls} data-testid={`lesson-download-audio-${id}`}>
          <Headphones className="h-4 w-4" /> Download Audio (MP3)
        </a>
      )}
      {lesson.pdf_url && (
        <a href={getDownloadUrl(lesson.pdf_url, lessonFileName(lesson, 'pdf'))} className={secondaryCls} data-testid={`lesson-download-pdf-${id}`}>
          <FileText className="h-4 w-4" /> Download PDF
        </a>
      )}
      {lesson.video_url && (
        <a href={getDownloadUrl(lesson.video_url, lessonFileName(lesson, 'mp4'))} className={secondaryCls} data-testid={`lesson-download-video-${id}`}>
          <Download className="h-4 w-4" /> Download Video (MP4)
        </a>
      )}
    </div>
  );
};
